import './index.scss';
import React from 'react';
import { Accordion } from 'react-bootstrap';
import PermissionChecker from '~/components/permission_checker';
import SidebarSection from '~/components/sidebar_section';
import Permissions from '~/settings/permissions';
import { useContentLibrary } from '../../providers/content_library_provider';
import AccordionCollapse from './accordion_collapse';
import AccordionToggle from './accordion_toggle';
const ParentDocumentsPanel = () => {
    const { activeClause, clauseParentMetadata, selectedDocuments, toggleSelectedDocument, } = useContentLibrary();
    const hasParentMetadata = activeClause === null || activeClause === void 0 ? void 0 : activeClause.source.parentDocuments.every(pd => clauseParentMetadata.findIndex(fileMeta => fileMeta.file.id === pd.id) !== -1);
    const ParentDocuments = () => {
        if (activeClause === null || activeClause === void 0 ? void 0 : activeClause.source.parentDocuments) {
            if (hasParentMetadata) {
                const parentDocs = activeClause.source.parentDocuments.map((doc, index) => {
                    const isChecked = selectedDocuments.some(document => document.id === doc.id);
                    const fileMetadata = clauseParentMetadata.find(fileMeta => fileMeta.file.id === doc.id);
                    if (!fileMetadata)
                        return React.createElement(React.Fragment, null);
                    return (React.createElement("div", { className: 'document-accordion-section', key: doc.id, "data-testid": `parent-document-container-${index}` },
                        React.createElement("input", { className: 'document-accordion-checkbox', checked: isChecked, type: 'checkbox', onChange: () => toggleSelectedDocument({
                                id: doc.id, name: doc.name, txId: '', docType: '',
                            }) }),
                        React.createElement("div", null,
                            React.createElement(AccordionToggle, { doc: doc }),
                            activeClause.source.parentDocuments.length === 1 &&
                                React.createElement(Accordion, { defaultActiveKey: `${doc.id}-id` },
                                    React.createElement(AccordionCollapse, { metadata: fileMetadata, doc: doc })),
                            activeClause.source.parentDocuments.length > 1 &&
                                React.createElement(AccordionCollapse, { metadata: fileMetadata, doc: doc }))));
                });
                return (React.createElement(React.Fragment, null, parentDocs));
            }
            else {
                return (React.createElement("div", { className: 'text-center' }, "Loading..."));
            }
        }
        return (React.createElement("div", { className: 'sidebar-section-empty' },
            React.createElement("span", null,
                React.createElement("i", { className: 'fas fa-mouse-pointer' })),
            React.createElement("div", null, "Click on a clause to learn more about its parent.")));
    };
    return (React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.VIEW_PARENT_DOCUMENTS] },
        React.createElement(SidebarSection, { title: 'Parent Documents', className: 'parent-documents-panel-container', isActive: !!(activeClause === null || activeClause === void 0 ? void 0 : activeClause.source.parentDocuments) },
            React.createElement("div", { className: 'accordion-wrapper' },
                React.createElement(Accordion, { className: 'document-accordion' },
                    React.createElement(ParentDocuments, null))))));
};
export default ParentDocumentsPanel;
